var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClaimService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#claim-service_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.86 6.976c.74.468.963 1.449.497 2.192l-6.285 10.014a1.582 1.582 0 01-2.185.499 1.592 1.592 0 01-.498-2.192l6.285-10.015a1.582 1.582 0 012.186-.498z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.579 16.992c.74.47.96 1.452.49 2.193-.86 1.363-2.042 3.115-3.81 4.136a1.582 1.582 0 01-2.165-.585 1.592 1.592 0 01.583-2.17c1.018-.588 1.841-1.697 2.715-3.082a1.582 1.582 0 012.187-.492z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.84 21.148c.438.76.179 1.732-.579 2.171l-9.413 5.46c-.758.439-1.727.179-2.165-.58a1.592 1.592 0 01.578-2.173l9.413-5.459a1.582 1.582 0 012.166.58z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.384 22.418c.871.083 1.51.858 1.428 1.733-.1 1.072-.065 1.802.037 2.267.059.27.125.39.157.434.049.008.17.016.402-.032.424-.088 1.037-.33 1.866-.8a1.582 1.582 0 012.16.6 1.592 1.592 0 01-.598 2.166c-.963.547-1.903.964-2.786 1.147-.888.184-1.895.165-2.777-.412-.88-.575-1.318-1.497-1.52-2.422-.202-.922-.212-2.021-.096-3.248a1.586 1.586 0 011.727-1.433zm1.594 4.426l.007.003a.03.03 0 01-.007-.003zm.04.025a.022.022 0 01.006.005l-.005-.005z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.348 12.062a1.588 1.588 0 011.431 1.73l-.96 10.355a1.586 1.586 0 01-1.724 1.436 1.588 1.588 0 01-1.431-1.73l.96-10.356a1.586 1.586 0 011.724-1.435z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.497 8.179c.74.468.962 1.45.495 2.192-.55.877-1.086 2.069-1.213 3.422a1.586 1.586 0 01-1.726 1.434 1.588 1.588 0 01-1.43-1.731c.187-1.992.96-3.661 1.688-4.82a1.582 1.582 0 012.186-.497z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.666.182c.736.476.946 1.46.47 2.197l-5.16 8.008a1.582 1.582 0 01-2.192.471 1.592 1.592 0 01-.47-2.197L47.475.653a1.582 1.582 0 012.191-.471zM51.73 13.14c-.795-.49-1.758-.242-2.18.373a1.582 1.582 0 01-2.203.41 1.593 1.593 0 01-.409-2.21c1.44-2.103 4.312-2.596 6.446-1.284 2.218 1.344 3.043 4.23 1.633 6.475a1.582 1.582 0 01-2.186.498 1.592 1.592 0 01-.496-2.192c.394-.627.227-1.567-.592-2.061l-.014-.008z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.344 16.718c-.513-.312-1.074-.134-1.304.203a1.582 1.582 0 01-2.203.412 1.592 1.592 0 01-.411-2.21c1.248-1.827 3.715-2.247 5.562-1.122 1.904 1.155 2.638 3.658 1.407 5.61a1.582 1.582 0 01-2.187.494 1.592 1.592 0 01-.492-2.193c.205-.324.143-.88-.37-1.192l-.002-.002zM46.4 10.679c-.512-.315-1.092-.138-1.328.207a1.582 1.582 0 01-2.204.41 1.592 1.592 0 01-.408-2.21c1.255-1.832 3.743-2.254 5.592-1.12 1.904 1.156 2.672 3.664 1.416 5.642-.47.74-1.45.959-2.189.487a1.593 1.593 0 01-.485-2.195c.207-.326.152-.89-.385-1.215l-.01-.006zM40.067 19.47a1.585 1.585 0 011.846-1.274 15.833 15.833 0 015.3 2.001l.005.003a15.29 15.29 0 013.8 3.272 1.593 1.593 0 01-.2 2.24 1.582 1.582 0 01-2.232-.2 12.117 12.117 0 00-3.01-2.592 12.669 12.669 0 00-4.238-1.598 1.59 1.59 0 01-1.27-1.852zM65.016 39.963c.875 0 1.584.712 1.584 1.59v32.092c0 .878-.71 1.59-1.584 1.59a1.587 1.587 0 01-1.585-1.59V41.552c0-.877.71-1.59 1.585-1.59z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.016 72.055c.875 0 1.584.711 1.584 1.59 0 3.565-2.974 6.429-6.511 6.429a1.587 1.587 0 01-1.585-1.59c0-.878.71-1.59 1.585-1.59 1.852 0 3.342-1.506 3.342-3.25 0-.878.71-1.59 1.585-1.59z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.842 78.484c0-.878.71-1.59 1.585-1.59h53.662c.875 0 1.585.712 1.585 1.59 0 .878-.71 1.59-1.585 1.59H6.427a1.587 1.587 0 01-1.585-1.59z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.514 72.055c.876 0 1.585.711 1.585 1.59 0 1.76 1.484 3.25 3.328 3.25.875 0 1.585.711 1.585 1.59 0 .877-.71 1.589-1.585 1.589-3.531 0-6.498-2.852-6.498-6.43 0-.878.71-1.59 1.585-1.59z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.722.34a1.582 1.582 0 011.065-.412H60.09c.875 0 1.585.711 1.585 1.59 0 .877-.71 1.589-1.585 1.589H23.398L3.1 21.58v52.064c0 .878-.71 1.59-1.585 1.59a1.587 1.587 0 01-1.585-1.59V20.877c0-.449.19-.876.52-1.177L21.722.34z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.504 1.516c0-.878.71-1.59 1.585-1.59 3.554 0 6.511 2.868 6.511 6.43 0 .878-.71 1.59-1.584 1.59a1.587 1.587 0 01-1.585-1.59c0-1.747-1.479-3.25-3.342-3.25a1.587 1.587 0 01-1.585-1.59z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.016 4.767c.875 0 1.584.711 1.584 1.59v35.195c0 .878-.71 1.59-1.584 1.59a1.587 1.587 0 01-1.585-1.59V6.356c0-.878.71-1.59 1.585-1.59zM23.767-.073c.875 0 1.585.711 1.585 1.59v17.85c0 .878-.71 1.59-1.585 1.59a1.587 1.587 0 01-1.585-1.59V1.517c0-.879.71-1.59 1.585-1.59z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.767 17.777c.875 0 1.585.712 1.585 1.59 0 2.332-1.935 4.18-4.216 4.18a1.587 1.587 0 01-1.584-1.59c0-.877.71-1.589 1.584-1.589.592 0 1.046-.486 1.046-1.001 0-.878.71-1.59 1.585-1.59z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-.07 21.958c0-.878.709-1.59 1.584-1.59h19.63c.875 0 1.584.712 1.584 1.59 0 .878-.71 1.59-1.585 1.59H1.514a1.587 1.587 0 01-1.585-1.59zM7.693 34.093c0-.877.71-1.59 1.585-1.59h38.966c.876 0 1.585.713 1.585 1.59 0 .878-.71 1.59-1.585 1.59H9.278a1.587 1.587 0 01-1.585-1.59zM7.693 46.228c0-.878.71-1.59 1.585-1.59H42.2c.876 0 1.585.712 1.585 1.59 0 .878-.71 1.59-1.585 1.59H9.278a1.587 1.587 0 01-1.585-1.59zM7.693 58.363c0-.878.71-1.59 1.585-1.59h38.966c.876 0 1.585.712 1.585 1.59 0 .878-.71 1.59-1.585 1.59H9.278a1.587 1.587 0 01-1.585-1.59zM7.693 70.499c0-.878.71-1.59 1.585-1.59H58.73c.875 0 1.585.712 1.585 1.59 0 .878-.71 1.59-1.585 1.59H9.278a1.587 1.587 0 01-1.585-1.59z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.016 61.723c8.547 0 15.477-6.938 15.477-15.495 0-8.557-6.93-15.495-15.477-15.495-8.548 0-15.478 6.938-15.478 15.495 0 8.557 6.93 15.495 15.478 15.495z",
    fill: "#E5EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.016 32.323c-7.676 0-13.893 6.228-13.893 13.905s6.217 13.905 13.893 13.905c7.675 0 13.892-6.228 13.892-13.905s-6.217-13.905-13.892-13.905zM47.954 46.228c0-9.438 7.641-17.084 17.062-17.084 9.42 0 17.062 7.646 17.062 17.084 0 9.438-7.642 17.084-17.062 17.084-9.42 0-17.062-7.646-17.062-17.084z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.539 40.479a1.672 1.672 0 01-.002 2.308l-8.46 8.736a1.54 1.54 0 01-2.23 0l-4.385-4.533a1.672 1.672 0 010-2.308 1.54 1.54 0 012.23 0l3.27 3.38 7.346-7.585a1.54 1.54 0 012.231.002z",
    fill: "#ED1B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "claim-service_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h82v80H0z"
  })))));
}

export default SvgClaimService;